import { graphql } from "@opensea/graphql"
import { CreateOfferFlowTableRowFragment } from "./CreateOfferFlowTableRow.fragment"

export const CreateOfferFlowTableFragment = graphql(
  `
    fragment CreateOfferFlowTable on Item {
      id
      ...CreateOfferFlowTableRow
    }
  `,
  [CreateOfferFlowTableRowFragment],
)
